import cornerstone from 'cornerstone-core';

export default function(element, imageId) {
  if (!imageId) {
    // Get the Cornerstone imageId
    const enabledElement = cornerstone.getEnabledElement(element);
    imageId = enabledElement.image.imageId;
  }

  // Get StudyInstanceUID & PatientID
  // mprblob imageIds have no DICOM instance metadata — return null safely.
  if (imageId && imageId.startsWith('mprblob:')) {
    return { PatientID: null, StudyInstanceUID: null, SeriesInstanceUID: null, SOPInstanceUID: null, frameIndex: 0, imagePath: null };
  }
  const instanceMeta = cornerstone.metaData.get('instance', imageId);
  if (!instanceMeta) {
    return { PatientID: null, StudyInstanceUID: null, SeriesInstanceUID: null, SOPInstanceUID: null, frameIndex: 0, imagePath: null };
  }
  const {
    StudyInstanceUID,
    PatientID,
    SeriesInstanceUID,
    SOPInstanceUID,
  } = instanceMeta;

  const splitImageId = imageId.split('&frame');
  const frameIndex =
    splitImageId[1] !== undefined ? Number(splitImageId[1]) : 0;

  const imagePath = [
    StudyInstanceUID,
    SeriesInstanceUID,
    SOPInstanceUID,
    frameIndex,
  ].join('_');

  return {
    PatientID,
    StudyInstanceUID,
    SeriesInstanceUID,
    SOPInstanceUID,
    frameIndex,
    imagePath,
  };
}
